import React, {Component} from 'react';
import {Tab, Tabs} from "react-bootstrap";
import $ from "jquery";
import GetAuth from "../diyComponents/Postman";
import SendInvoiceToPaymentQueue from "../diyComponents/sendInvoiceToPaymentQueue";
import GetPaymentStatus from "../diyComponents/getPaymentStatus"
import axios from "axios";
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";

class ApiHome extends Component {

    state = {
        isDevOptionAccessAPIHome: false
    }

    componentDidMount() {
        this.isValidIntegrationKey();
        this.getDevOptionsPermission();
    }

    isValidIntegrationKey() {
        axios.post(config.get('API_URL') + '/diyusers/verify-expiryDate', {},
            {
                headers: {
                    Authorization: `${localStorage.usertoken}`
                }
            })
            .then(response => {
                try {
                    if (response.data.status == 'expired') {
                        alert("Session Has been expired.");
                        setTimeout(function () {
                            localStorage.removeItem("usertoken");
                            window.location.href = "/";
                        }.bind(this), 1000);
                    } else {
                        console.log(response.data);
                    }
                } catch (err) {
                    console.log("expired check failed!");
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    changeTab(key) {
        if ($.fn.DataTable.isDataTable('#queryBuilderTable')) {
            $('#queryBuilderTable').DataTable().clear().destroy();
            $('#queryBuilderTable').html('');
        }
    }

    getDevOptionsPermission() {
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;

        if(AllAccessPermissions !== undefined) {
            AllAccessPermissions.map((permissionName, i) => {
                if (permissionName.access_type == 'Action' && permissionName.access_name == 'advance_developer_option') {
                    this.setState({
                        isDevOptionAccessAPIHome: true
                    })
                }
            });
        }
    }

    getCollection = () => {
        fetch(config.get('API_URL') + '/diyusers/getCollections', {headers: {Authorization: ` ${localStorage.usertoken}`}})
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = 'cloudintegration_collections.json';
                    a.click();
                });
            }).catch(function (err) {
            alert("Error while downloading collections!");
        });
    }

    getEnvironments = () => {
        fetch(config.get('API_URL') + '/diyusers/getCustomEnvironments', {headers: {Authorization: ` ${localStorage.usertoken}`}})
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = 'cloudintegration_enviorment.json';
                    a.click();
                });
            }).catch(function (err) {
            alert("Error while downloading environments!");
        });
    }

    renderDevAdvanceButtons() {
        if (this.state.isDevOptionAccessAPIHome === false) {
            return <div></div>;
        } else {
            return (
                <div className="col-md-6 p-0 pull-right diyRightText">
                    <br />


                    <a href="#" className="addButton" role="button" onClick={this.getEnvironments}>
                        <span className="glyphicon glyphicon-download-alt"> </span> User Profile
                    </a>
                    &nbsp;&nbsp;
                    <a href="#" className="addButton" role="button" onClick={this.getCollection}>
                        <span className="glyphicon glyphicon-download-alt"> </span> API Calls
                    </a>
                    &nbsp;&nbsp;
                    <a href="https://documenter.getpostman.com/view/9772818/SzS4ToK7?version=latest" target="_blank">
                        <img src="https://run.pstmn.io/button.svg" alt="Run in Postman"/>
                    </a>

                </div>
            );
        }
    }
    render() {
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="col-md-12 leftBody header">
                                    <div className="col-md-6 p-0">
                                        <h4 className="title">Billing Server APIs </h4>
                                    </div>
                                    {this.renderDevAdvanceButtons()}

                                </div>
                                <Tabs defaultActiveKey="getAuthToken" id="query-builder-tab"
                                      onClick={() => this.changeTab()}>
                                    <Tab eventKey="getAuthToken" title="Authentication">
                                        <GetAuth/>
                                    </Tab>

                                    <Tab eventKey="sendInvoiceToPaymentQueue" title="Send Invoice">
                                        <SendInvoiceToPaymentQueue/>
                                    </Tab>
                                    <Tab eventKey="getPaymentStatus" title="Fetch Status">
                                        <GetPaymentStatus/>
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ApiHome;